import React, { useState } from "react";
import { motion } from "framer-motion";
import { COLORS } from "@/lib/shop";
import { scrollToId } from "@/lib/scroll";
import Reveal from "@/components/Reveal";
import ProductGallery from "@/components/ProductGallery";

export default function Showcase() {
    const [active, setActive] = useState("cream");
    const color = COLORS.find((c) => c.id === active);

    return (
        <section id="texture" className="bg-white pt-14 pb-8 md:py-24 scroll-mt-[4.25rem]">
                    <div className="max-w-6xl mx-auto px-4 sm:px-6 grid md:grid-cols-2 gap-6 md:gap-14 items-center">
                <Reveal>
                    {/* ─── Product Gallery (6 images, swipe, thumbnails) ─── */}
                    <ProductGallery />
                </Reveal>
                <Reveal delay={0.12}>
                    {/* ─── Price + CTA (above heading) ─── */}
                    <motion.div
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                                                                className="mt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2.5"
                        data-testid="texture-price-cta"
                    >
                        <div className="flex items-end gap-2">
                                                    <span className="text-2xl sm:text-4xl font-extrabold text-[#9E3B1B] font-sans">৳৯০০</span>
                                                    <span className="text-base sm:text-lg text-[#8A8278] line-through mb-0.5">৳১,৩০০</span>
                                                    <span className="text-[11px] sm:text-xs font-semibold text-[#2D5A43] bg-[#E4EFE8] border border-[#C6DCCF] rounded-full px-2.5 sm:px-3 py-0.5 sm:py-1 mb-1">৳৪০০ ছাড়</span>
                        </div>
                                                                    <div className="flex items-center gap-2 w-full sm:w-auto">
                                                <button
                                                    onClick={() => scrollToId("order-form")}
                                                    data-testid="texture-order-button"
                                                                                                className="flex-1 sm:flex-none bg-[#A84320] text-[#FBF9F5] font-semibold px-4 sm:px-6 py-2 sm:py-2.5 rounded-full text-[13px] sm:text-sm hover:bg-[#8C3417] active:scale-[0.98] transition-all duration-200 shadow-lg shadow-[#A84320]/25"
                                                >
                                                    এখনই অর্ডার করুন
                                                </button>
                                                <button
                                                    onClick={() => scrollToId("order-form")}
                                                    data-testid="texture-variants-button"
                                                                                                className="flex-1 sm:flex-none border border-[#1A1715]/25 text-[#1E1B18] font-semibold px-4 sm:px-6 py-2 sm:py-2.5 rounded-full text-[13px] sm:text-sm hover:border-[#1A1715] hover:bg-white active:scale-[0.98] transition-all duration-200"
                                                    >
                                                    কালার ও সাইজ দেখুন
                                                    </button>
                                            </div>
                                        </motion.div>

                    <h2 className="font-serif text-xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#1E1B18] mt-3">
                        খাদির টেক্সচার, কাছ থেকে দেখুন
                    </h2>
                                        <p className="mt-3 sm:mt-4 text-sm sm:text-base text-[#4A453F] leading-relaxed">
                        হাতে বোনা খাদি কাপড়ের স্বাভাবিক ভাঁজ ও টেক্সচার প্রতিটি পাঞ্জাবিকে দেয় আলাদা চরিত্র।
                        প্রিমিয়াম মেটাল বাটন ও ডাবল-স্টিচ ফিনিশিং — প্রতিটি বিবরণে যত্ন।
                    </p>
                    
                </Reveal>
            </div>
        </section>
    );
}